<div class="autocomplete-dropdown-component">
    <mat-form-field class="width-100">
      @if (title) {
        <mat-label>{{ title }}</mat-label>
      }
      <input 
        type="text" 
        #mapInput
        matInput 
        [placeholder]="placeholder" 
        [readonly]="readOnly" 
        [formControl]="formControl"
        [matAutocomplete]="auto"
        (keydown)="handleKeydown($event)"
        required
      />
       
      <mat-autocomplete 
        #auto="matAutocomplete" 
        [displayWith]="displayWithFn" 
        (optionSelected)="onOptionSelected($event)"
        autoActiveFirstOption="false"
        class="autocomplete-panel"
      >
        @if (filteredItems.length > 0) {
          @for (item of filteredItems; track item) {
            <mat-option [value]="item">
              {{ displayWithFn(item) }}
            </mat-option>
          }
        } @else if (formControl.value && formControl.value.address && formControl.value.address.trim().length > 0) {
          <mat-option [value]="null" disabled>
            <div class="option-label">
              No results found
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      @if (state === 'loading') {
        <mat-spinner diameter="25" matSuffix class="spinner-suffix"></mat-spinner>
      }
      @if (formControl.touched && formControl.invalid) {
        <mat-error>
          @if (formControl.hasError('required')) {
            This field is required
          }
        </mat-error>
      }
    </mat-form-field>
  </div> 